export function getAuthBaseURL(fallbackUrl?: string): string {
  if (typeof globalThis !== "undefined" && "window" in globalThis) {
    const win = (globalThis as { window?: { location?: { origin: string } } }).window;
    if (win?.location?.origin) {
      return win.location.origin;
    }
  }

  return fallbackUrl || "http://localhost:3000";
}
